import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const SOPRA_ENDPOINTS = {
  V2: createEndpoints('v2', {
    CLASSIFICATIONS: '/classifications/',
    CLASSIFICATION: (id: number) => `/classifications/${id}/`,
  }),
} as const;
